import { render, staticRenderFns } from "./videoNumberGoods.vue?vue&type=template&id=7f827461&scoped=true&"
import script from "./videoNumberGoods.vue?vue&type=script&lang=js&"
export * from "./videoNumberGoods.vue?vue&type=script&lang=js&"
import style0 from "./videoNumberGoods.vue?vue&type=style&index=0&id=7f827461&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f827461",
  null
  
)

export default component.exports